<template>
	<div>
		<link
			rel="stylesheet"
			href="https://admin.clockmaker.co.uk/static/pdf.css"
		/>

		<quote-layout :quoteId="$router.currentRoute.params.id" />
	</div>
</template>

<script>
import PDFService from "@/api-services/pdf.service";
import QuoteLayout from "@/components/quote/quote-layout";
import { dateFuncs } from "@/globs.js";

export default {
	name: "quoteIFrame",

	components: {
		PDFService,
		QuoteLayout,
	},

	mounted() {
		window.addEventListener("message", this.receiveMessage);
	},

	beforeDestroy() {
		window.removeEventListener("message", this.receiveMessage);
	},

	methods: {
		receiveMessage(e) {
			if (
				e.data.event_id ==
				"download_" + this.$router.currentRoute.params.id
			) {
				let rawHTML = this.c;

				//let safeHTML = JSON.stringify(rawHTML);

				let dto = {
					HTML: rawHTML,
				};

				PDFService.create(dto).then((response) => {
					let blob = new Blob([response.data], {
							type: "application/pdf",
						}),
						url = window.URL.createObjectURL(blob);
					let a = document.createElement("a");
					a.href = url;
					a.download =
						"Cumbria_Clock_Company_quote_" +
						e.data.ref +
						"-rev" +
						e.data.rev +
						".pdf";
					a.click();
					window.URL.revokeObjectURL(url);
				});
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/quote/quote-iframe.vue